import { render, staticRenderFns } from "./GenerateMPIN.vue?vue&type=template&id=17490390"
import script from "./GenerateMPIN.vue?vue&type=script&lang=js"
export * from "./GenerateMPIN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports